import { ProviderType } from 'features/connections'
import { buildAnalysisQueryFromSource } from '../../utils'
import { ClusteringKMeansQuery, ClusteringKMeansSettingsQueryParams } from '../types'
import { generateQuery as generateQueryForBigQuery } from './bq'
import { generateQuery as generateQueryForSnowflake } from './sf'
import { generateQuery as generateQueryForRedshift } from './rs'
import { generateQuery as generateQueryForPostgres } from './pg'

export function generateClusteringKMeansQuery({ mainSource, clusters, atLocation }: ClusteringKMeansQuery): string {
  const baseQuery = buildAnalysisQueryFromSource({ source: mainSource })
  const geomField = mainSource.geoColumn || mainSource.metadata?.schema?.find((c) => c.type === 'geometry')?.name

  const payload: ClusteringKMeansSettingsQueryParams = {
    geomField,
    clusters,
    baseQuery: baseQuery,
    atLocation
  }

  const connectionProvider = mainSource.providerId
  switch (connectionProvider) {
    case ProviderType.BIGQUERY:
      return generateQueryForBigQuery(payload)
    case ProviderType.SNOWFLAKE:
      return generateQueryForSnowflake(payload)
    case ProviderType.REDSHIFT:
      return generateQueryForRedshift(payload)
    case ProviderType.POSTGRES:
      return generateQueryForPostgres(payload)
    default:
      throw new Error(`Analysis not implemented for ${connectionProvider}`)
  }
}
